import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] pt-20 pb-10 border-t border-gold/20" data-id="element-85">
      <div className="container mx-auto px-6 md:px-12" data-id="element-86">
        <div className="flex justify-center mb-16" data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/3ADQKp1DHnDUdGH3xP27Pb/Onyx__Steel_Logo-Sin_fondo.png" alt="Onyx & Steel Logo" className="h-28 md:h-36 object-contain opacity-90" data-id="element-88" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left mb-16" data-id="element-89">
          <div data-id="element-90">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase mb-6 font-medium" data-id="element-91">
              Schedule
            </h4>
            <ul className="space-y-3 text-white/60 font-light text-sm" data-id="element-92">
              <li data-id="element-93">Mon-Fri: 9AM - 8PM</li>
              <li data-id="element-94">Sat: 8AM - 6PM</li>
              <li data-id="element-95">Sun: 10AM - 4PM</li>
            </ul>
          </div>

          <div data-id="element-96">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase mb-6 font-medium" data-id="element-97">
              Contact
            </h4>
            <ul className="space-y-3 text-white/60 font-light text-sm" data-id="element-98">
              <li data-id="element-99">Phone: (555) 123-4567</li>
              <li data-id="element-100">Email: info@onyxandsteel.com</li>
              <li data-id="element-101">Instagram: @onyxandsteel</li>
            </ul>
          </div>

          <div data-id="element-102">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase mb-6 font-medium" data-id="element-103">
              Location
            </h4>
            <p className="text-white/60 font-light text-sm leading-relaxed" data-id="element-104">
              123 Main Street
              <br data-id="element-105" />
              Suite 100
              <br data-id="element-106" />
              New York, NY 10001
            </p>
          </div>
        </div>

        <div className="text-center border-t border-white/10 pt-8" data-id="element-107">
          <p className="text-white/40 text-xs font-light tracking-wider" data-id="element-108">
            © 2025 Onyx & Steel Barbershop. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}